import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

const Pagination = ({
  currentPage =1,
  totalPages = 0,
  onPageChange,
  itemsPerPage = 10,
  onItemsPerPageChange,
  totalCount = 0,
}) => {
  const itemsPerPageOptions = [5, 10, 15, 20,50,100, 200, 500];

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    onItemsPerPageChange(newItemsPerPage);
  };

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalCount);

  return (
    <div>
      {/* Desktop Pagination */}
      <div className="hidden md:flex items-center justify-between py-2.5 ">
        <div className="flex items-center space-x-1 ">
          <span className="text-text2 text-xs lg:text-sm">Results per page:</span>
          <div className=" secondary-dropdown ">
            <select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              className=" rounded text-xs lg:text-sm  font-normal text-text1 uppercase focus:outline-none focus:ring-0  w-full  cursor-pointer "
            >
              {itemsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex items-center">
          <button
            className={`flex items-center justify-center w-8 h-8 rounded-l-md border-r-0 border border-gray-300 ${
              currentPage === 1
                ? "opacity-50 pointer-events-none"
                : "cursor-pointer"
            }`}
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            <FaAngleLeft className="text-gray-500" />
          </button>

          {getPageNumbers().map((pageNumber, index) => (
            <div className=" border-l-[1px] border-gray-300 border-r-0">

            <button
              key={index}
              className={`flex items-center justify-center w-8 h-8 border-gray-300 border border-l-0 border-r-0  ${
                currentPage === pageNumber
                  ? "bg-gray-300 text-black"
                  : "text-gray-700 hover:bg-gray-200"
              }`}
              disabled={pageNumber === "..."}
              onClick={() => pageNumber !== "..." && onPageChange(pageNumber)}
            >
              <span className="text-xs lg:text-sm ">
              {pageNumber}</span>
            </button>
            </div>
          ))}

          <button
            className={`flex items-center justify-center w-8 h-8 rounded-md border rounded-l-none border-gray-300 ${
              currentPage === totalPages
                ? "opacity-50 pointer-events-none"
                : "cursor-pointer"
            }`}
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          >
            <FaAngleRight className="text-gray-500" />
          </button>
        </div>

        <div>
          <span className="text-xs lg:text-sm  text-text2">
            {`Showing ${startItem} to ${endItem} of ${totalCount} results`}
          </span>
        </div>
      </div>

      {/* Mobile Pagination */}
      <div className="md:hidden flex flex-col space-y-2 py-2">
        <div className="flex justify-between space-x-4">
          <button
            className={`flex items-center justify-center h-10 border border-gray-300 px-3 py-1.5 w-fit rounded-md ${
              currentPage === 1
                ? "opacity-50 pointer-events-none"
                : "cursor-pointer"
            }`}
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            <span className="  text-text2 text-sm  ">Previous</span>
          </button>
          <button
            className={`flex items-center justify-center h-10 border border-gray-300 px-3 py-1.5 w-fit rounded-md ${
              currentPage === totalPages
                ? "opacity-50 pointer-events-none"
                : "cursor-pointer"
            }`}
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          >
            <span className="  text-text2 text-sm  ">Next</span>
          </button>
        </div>

        <div className="flex justify-between items-center">
          <span className="lg:text-xs text-[10px] text-gray-text2">
            {`Showing ${startItem} to ${endItem} of ${totalCount} results`}
          </span>
          <div className="flex items-center space-x-1">
            <span className="text-xs text-text2">Results per page:</span>
            <div className="secondary-dropdown">
              <select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className=" rounded px-1 text-sm font-normal text-text3 focus:outline-none focus:ring-0  w-full  cursor-pointer "
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
